import { ViewModel,View, ObservableArray } from "binder"
import moment, { Moment } from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { UnitSelectorViewModel } from "src/EnterpriseAdministration/unitManipulation/unitManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { ServerSideDataLoader, PaginationInfo, Enum, IEnumTranslator } from "uicomponents";
import { BrandSelectorViewModel } from "../brandManipulation/brandManipulation-viewModel";
import { ColorSelectorViewModel } from "../colorManipulation/colorManipulation-viewModel";
import { CountrySelectorViewModel } from "../countryManipulation/countryManipulation-viewModel";
import { PartNumberSearchViewModel, PartNumberSelectorViewModel } from "../partNumberManipulation/partNumberManipulation-viewModel";
import  { ProductCreationRequestManipulationView } from "./productCreationRequestManipulation-view"
import { CarBrandSelectorViewModel } from "../carBrandManipulation/carBrandManipulation-viewModel";


export class ProductCreationRequestManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت درخواست‌های ایجاد کالا ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.requestStateEnumProvider = new RequestStateEnumProvider();
        this.productCreationRequests = ObservableArray.create<ProductCreationRequest>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductCreationRequestManipulationView();
    }
    public getTypeId(): string {
        return "VM-C1B0F9C7-DC30-4494-8255-577D23CB6CD3"
    }
    public set requestStateEnumProvider(v: RequestStateEnumProvider) { this._requestStateEnumProvider = v; } public get requestStateEnumProvider(): RequestStateEnumProvider { return this._requestStateEnumProvider;} private _requestStateEnumProvider: RequestStateEnumProvider;
    public set productCreationRequests(v: ObservableArray<ProductCreationRequest>) { this._productCreationRequests = v; } public get productCreationRequests(): ObservableArray<ProductCreationRequest> { return this._productCreationRequests;} private _productCreationRequests: ObservableArray<ProductCreationRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set selectAll(v: boolean) { 
        this._selectAll = v; 
        if (v)
            this.productCreationRequests.forEach(x => x.selected = true);
        else
            this.productCreationRequests.forEach(x => x.selected = false);
    }
    public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;
    
    refresh(){
        this.selectAll = false;
        this.loader.refresh();
    }
    
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllProductCreationRequest',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.productCreationRequests.update(...result.ProductCreationRequest.map(q=>{
                let r = new ProductCreationRequest(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.providedCode = q.ProvidedCode;
                r.creationTime = moment.utc(q.CreationTime);
                r.determinationTime = q.DeterminationTime==null ? null : moment.utc(q.DeterminationTime);
                r.creatorId = q.CreatorId;
                r.creatorName = q.CreatorName;
                r.determinatorId = q.DeterminatorId;
                r.determinatorName = q.DeterminatorName;
                r.partNumberId = q.ProductId;
                r.partNumberName = q.ProductName;
                r.productIndex = q.ProductIndex;
                r.state = q.State;
                r.needConfirm = q.DeterminationTime ==null ? true : false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async confirm(productCreationRequest:ProductCreationRequest){
        let editor = new productCreationRequestEditor(this,new InsertServerUpdater());
        editor.id = productCreationRequest.id;
        editor.requestedWrittenCode = productCreationRequest.providedCode;
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async rejectSelected(selectedId:any):Promise<void>{
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','رد کردن درخواست ها');
        if(result=='yes'){
            try {
                this.isLoading = true;
                if (selectedId === null)
                    selectedId = this.productCreationRequests.filter(x=> x.selected).map(q => q.id);
                else 
                    selectedId = [selectedId];
                await ServerConnection.callServer('/Complex/WarehouseServices/RejectProductCreationRequest',{
                    Ids: selectedId
                });
                await this.messageBoxConfirmSuccess('درخواست های انتخاب شده رد شدند.','عملیات موفق');
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            } finally {
                this.isLoading = false;
                this.loader.refresh();
            }
        }
    }

}

export class ProductCreationRequest extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ProductCreationRequestManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set providedCode(v: string) { this._providedCode = v; } public get providedCode(): string { return this._providedCode;} private _providedCode: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set determinationTime(v: moment.Moment) { this._determinationTime = v; } public get determinationTime(): moment.Moment { return this._determinationTime;} private _determinationTime: moment.Moment;
    public set creatorId(v: string) { this._creatorId = v; } public get creatorId(): string { return this._creatorId;} private _creatorId: string;
    public set creatorName(v: string) { this._creatorName = v; } public get creatorName(): string { return this._creatorName;} private _creatorName: string;
    public set determinatorId(v: string) { this._determinatorId = v; } public get determinatorId(): string { return this._determinatorId;} private _determinatorId: string;
    public set determinatorName(v: string) { this._determinatorName = v; } public get determinatorName(): string { return this._determinatorName;} private _determinatorName: string;
    public set partNumberId(v: string) { this._partNumberId = v; } public get partNumberId(): string { return this._partNumberId;} private _partNumberId: string;
    public set partNumberName(v: string) { this._partNumberName = v; } public get partNumberName(): string { return this._partNumberName;} private _partNumberName: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set brandId(v: string) { this._brandId = v; } public get brandId(): string { return this._brandId;} private _brandId: string;
    public set brandName(v: string) { this._brandName = v; } public get brandName(): string { return this._brandName;} private _brandName: string;
    public set colorId(v: string) { this._colorId = v; } public get colorId(): string { return this._colorId;} private _colorId: string;
    public set colorName(v: string) { this._colorName = v; } public get colorName(): string { return this._colorName;} private _colorName: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName;} private _carModelName: string;
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set countryId(v: string) { this._countryId = v; } public get countryId(): string { return this._countryId;} private _countryId: string;
    public set countryName(v: string) { this._countryName = v; } public get countryName(): string { return this._countryName;} private _countryName: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set unitId(v: string) { this._unitId = v; } public get unitId(): string { return this._unitId;} private _unitId: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state;} private _state: number;
    public set needConfirm(v: boolean) { this._needConfirm = v; } public get needConfirm(): boolean { return this._needConfirm;} private _needConfirm: boolean;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    private _typedParent:ProductCreationRequestManipulationViewModel;

    async confirmRequest(){
        this._typedParent.confirm(this);
    } 

    async rejectRequest(){
        this._typedParent.rejectSelected(this.id);
    } 

    setPartNumberId(id: string, name: string) {
        this.partNumberId = id;
        this.partNumberName = name;
    }
    
    getPartNumberId() {
        return this.partNumberId;
    }    

    setBrand(id: string, name: string) {
        this.brandId = id;
        this.brandName = name;
    }
    
    getBrandId() {
        return this.brandId;
    }    

    setColor(id: string, name: string) {
        this.colorId = id;
        this.colorName = name;
    }

    getColorId() {
        return this.colorId;
    }    

    setCountry(id: string, name: string) {
        this.countryId = id;
        this.countryName = name;
    }
    
    getCountryId() {
        return this.countryId;
    }    

    setModel(id: string, name: string) {
        this.carModelId = id;
        this.carModelName = name;
    }

    getModelId() {
        return this.carModelId;
    }    

    setUnit(id: string, name: string) {
        this.unitId = id;
        this.unitName = name;
    }
    
    getUnitId() {
        return this.unitId;
    }    

}

interface IServerUpdater{
    execute(productCreationRequest:ProductCreationRequest):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'محصول با موفقیت ثبت شد.';
    }

    async execute(productCreationRequest: ProductCreationRequest): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/ConfirmProductCreationRequest',{
            ProductCreationRequestId:productCreationRequest.id,
            PartNumberId:productCreationRequest.getPartNumberId(),
            CountryId:productCreationRequest.getCountryId(),
            CarModelId:productCreationRequest.getModelId(),
            ColorId:productCreationRequest.getColorId(),
            BrandId:productCreationRequest.getBrandId(),
            ProductIndex:productCreationRequest.productIndex,
            UnitId:productCreationRequest.getUnitId()
        });
        if(result.IsSuccessful==false){
            if(result.IsSuccessful==false){
                if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                    throw "این کالا قبلا تعریف شده است";
            }
        }
    }

}

export class productCreationRequestEditor extends ProductCreationRequest implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ProductCreationRequestManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.brandSelector = new BrandSelectorViewModel(this);
        this.colorSelector = new ColorSelectorViewModel(this);
        this.countrySelector = new CountrySelectorViewModel(this);
        this.unitSelector = new UnitSelectorViewModel(this);
        this.partNumberSelector = new PartNumberSearchViewModel(this);
        this.partNumberSelector.onSelectionChanged = q=>{
            this.pncName = q.pncName;
            this.partNumberName = q.code;
        }
        this.carModelSelector = new CarBrandSelectorViewModel(this);
        this.partNumberSelector.onSelectionChanged = q=>{
            this.pncName = q.pncName;
            this.partNumberName = q.code;
        }
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set requestedWrittenCode(v: string) { this._requestedWrittenCode = v; } public get requestedWrittenCode(): string { return this._requestedWrittenCode;} private _requestedWrittenCode: string;
    public set brandSelector(v: BrandSelectorViewModel) { this._brandSelector = v; } public get brandSelector(): BrandSelectorViewModel { return this._brandSelector;} private _brandSelector: BrandSelectorViewModel;
    public set partNumberSelector(v: PartNumberSearchViewModel) { this._partNumberSelector = v; } public get partNumberSelector(): PartNumberSearchViewModel { return this._partNumberSelector;} private _partNumberSelector: PartNumberSearchViewModel;
    public set colorSelector(v: ColorSelectorViewModel) { this._colorSelector = v; } public get colorSelector(): ColorSelectorViewModel { return this._colorSelector;} private _colorSelector: ColorSelectorViewModel;
    public set carModelSelector(v: CarBrandSelectorViewModel) { this._carModelSelector = v; } public get carModelSelector(): CarBrandSelectorViewModel { return this._carModelSelector;} private _carModelSelector: CarBrandSelectorViewModel;
    public set countrySelector(v: CountrySelectorViewModel) { this._countrySelector = v; } public get countrySelector(): CountrySelectorViewModel { return this._countrySelector;} private _countrySelector: CountrySelectorViewModel;
    public set unitSelector(v: UnitSelectorViewModel) { this._unitSelector = v; } public get unitSelector(): UnitSelectorViewModel { return this._unitSelector;} private _unitSelector: UnitSelectorViewModel;
    

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.getPartNumberId())){
            result.push('کد محصول مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getColorId())){
            result.push('رنگ مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getCountryId())){
            result.push('کشور مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getModelId())){
            result.push('نوع خودرو مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getUnitId())){
            result.push('واحد مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getBrandId())){
            result.push('برند مشخص نشده است.')
        } 
        return result;
    }

    setPartNumber(id: string, name: string) {
        this.partNumberSelector.selectById(id);
    }

    getId() {
        return this.partNumberSelector.selectedItem?.id;
    }

    getPartNumberId() {
        return this.partNumberSelector.selectedItem?.id;
    }

    setColor(id: string, name: string) {
        this.colorSelector.selectById(id);
    }

    getColorId() {
        return this.colorSelector.selectedItem?.id;
    }
    
    setModel(id: string, name: string) {
        this.carModelSelector.selectById(id);
    }

    getModelId() {
        return this.carModelSelector.selectedItem?.id;
    }
    
    setCountry(id: string, name: string) {
        this.countrySelector.selectById(id);
    }

    getCountryId() {
        return this.countrySelector.selectedItem?.id;
    }

    setBrand(id: string, name: string) {
        this.brandSelector.selectById(id);
    }

    getBrandId() {
        return this.brandSelector.selectedItem?.id;
    }
    
    setUnit(id: string, name: string) {
        this.unitSelector.selectById(id);
    }
    
    getUnitId() {
        return this.unitSelector.selectedItem?.id;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت درخواست');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class RequestStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [1,2,3];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateProductRequestState(value);
    }
}
